import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./TermsAndConditions.css";
import HeroSection from "../../components/heroSection/HeroSection";
import Footer from "../../components/footer/Footer";

const TermsAndConditions = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userType, setUserType] = useState("host");
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    if (location.state && location.state.userType) {
      setUserType(location.state.userType);
    }
  }, [location.state]);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[id^="section-"]');
      const scrollPosition = window.scrollY + 150;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute("id");

        if (
          scrollPosition >= sectionTop &&
          scrollPosition < sectionTop + sectionHeight
        ) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); 

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSidebarClick = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 100;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
      setActiveSection(sectionId);
    }
  };

  const handleNavClick = (path) => {
    navigate(path);
  };

  const handleLogin = () => {
    navigate("/onboarding");
  };

  const handleGetStarted = () => {
    navigate("/onboarding");
  };

  const renderListItem = (text, additionalClassName = "") => (
    <p className={`terms_condition_list_item ${additionalClassName}`}>{text}</p>
  );

  const getHeaderText = () => {
    if (userType === "guest") {
      return "GUESTS TERMS AND CONDITIONS";
    }
    return "EVENT MANAGERS/PLANNERS TERMS AND CONDITIONS";
  };

  const getHeroDescription = () => {
    return "This outlines terms and conditions and obligations that you must accept in order to register on the App. By registering on the platform, you understand and have agreed to the terms and conditions hereunder as well as our general policies for platform use.";
  };

  const renderHostSidebar = () => (
    <>
      <a
        href="#section-1"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-1" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-1")}
      >
        1. Registering an Account
      </a>
      <a
        href="#section-2"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-2" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-2")}
      >
        2. Your Transactions
      </a>
      <a
        href="#section-3"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-3" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-3")}
      >
        3. Termination of Agreement
      </a>
      <a
        href="#section-4"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-4" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-4")}
      >
        4. Privacy Policy
      </a>
      <a
        href="#section-5"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-5" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-5")}
      >
        5. Relationship of the Parties
      </a>
      <a
        href="#section-6"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-6" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-6")}
      >
        6. Intellectual Property Rights
      </a>
      <a
        href="#section-7"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-7" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-7")}
      >
        7. Limitation of Liability
      </a>
      <a
        href="#section-8"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-8" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-8")}
      >
        8. Your Warranties and Indemnity
      </a>
      <a
        href="#section-9"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-9" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-9")}
      >
        9. Miscellaneous
      </a>
      <a
        href="#section-10"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-10" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-10")}
      >
        10. Revisions to App and Website
      </a>
      <a
        href="#section-11"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-11" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-11")}
      >
        11. Revisions to Terms
      </a>
    </>
  );

  // Render Guest Sidebar Navigation
  const renderGuestSidebar = () => (
    <>
      <a
        href="#section-1"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-1" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-1")}
      >
        1. Receiving Links
      </a>
      <a
        href="#section-2"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-2" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-2")}
      >
        2. Profile Creation
      </a>
      <a
        href="#section-3"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-3" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-3")}
      >
        3. Security Features
      </a>
      <a
        href="#section-4"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-4" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-4")}
      >
        4. Administrative Charges
      </a>
      <a
        href="#section-5"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-5" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-5")}
      >
        5. Refund Policies
      </a>
      <a
        href="#section-6"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-6" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-6")}
      >
        6. Privacy Policy
      </a>
      <a
        href="#section-7"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-7" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-7")}
      >
        7. Relationship of the Parties
      </a>
      <a
        href="#section-8"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-8" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-8")}
      >
        8. Intellectual Property Rights
      </a>
      <a
        href="#section-9"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-9" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-9")}
      >
        9. Limitation of Liability
      </a>
      <a
        href="#section-10"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-10" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-10")}
      >
        10. Your Warranties and Indemnity
      </a>
      <a
        href="#section-11"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-11" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-11")}
      >
        11. Miscellaneous
      </a>
      <a
        href="#section-12"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-12" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-12")}
      >
        12. Revisions to App and Website
      </a>
      <a
        href="#section-13"
        className={`terms_condition_sidebar_link ${
          activeSection === "section-13" ? "active" : ""
        }`}
        onClick={(e) => handleSidebarClick(e, "section-13")}
      >
        13. Revisions to Terms
      </a>
    </>
  );

  const renderHostTerms = () => (
    <>
      {/* Section 1: Registering an Account */}
      <div className="terms_condition_section" id="section-1">
        <h2 className="terms_condition_section_header">
          1. REGISTERING AN ACCOUNT
        </h2>

        <h3 className="terms_condition_sub_header" id="section-1-1">
          1.1 Profile Creation
        </h3>
        <p className="terms_condition_paragraph">
          1.1.1 You may be required to give detailed information about yourself
          via questionnaires and forms provided on the application portal. All
          answers to which are important as they form a part of your record
          which will be used for administrative purposes. You have a legal
          obligation to take reasonable care not to make a misrepresentation of
          yourself.
        </p>
        <p className="terms_condition_paragraph">
          1.1.2 In the event that any detail you have supplied to us is
          incorrect, you must advise the company immediately. Failure of which
          may lead to the termination or deactivation of your profile.
        </p>
        <p className="terms_condition_paragraph">
          1.1.3 You further agree to comply with any applicable administrative
          charges with regards to registration. You will be informed of any such
          charges in writing. Failure to make payment of the said charges shall
          be grounds for the denial of registration and you will therefore be
          barred or limited from optimal use of our app and website.
        </p>

        <h3 className="terms_condition_sub_header" id="section-1-2">
          1.2 Security Features
        </h3>
        <p className="terms_condition_paragraph">
          1.2.1 Due to the nature of transactions carried out on our platforms,
          the importance of security measure cannot be over emphasized. We
          reserve the right to adopt any security measures deemed fit in order
          to safeguard users of our platform at all times and also to ensure
          that our space is a safe business forum. We therefore may request that
          you go through our administrative processes for security and safety
          from time to time during and after your registration and listing
          process. Our security measures shall include but not be limited to the
          following:
        </p>
        {renderListItem(
          "a. Upload and verification of ID Cards from the relevant agencies."
        )}
        {renderListItem(
          "b. Request for any additional documents for personal data verification"
        )}
        {renderListItem(
          "c. Upload of company or business registration documents."
        )}
        {renderListItem(
          "d. Any other security and safety procedure deemed necessary at any time."
        )}

        <p className="terms_condition_paragraph">
          1.2.2 The company reserves the right to make requests at any time for
          additional documents or information relating to your person or
          business. Failure to comply will lead to the suspension or termination
          of the use of our platform.
        </p>
        <p className="terms_condition_paragraph">
          1.2.3 You hereby consent to the submission and verification of your
          personal information and agree that failure to comply with our
          administrative process shall be a ground for denial of use of our
          platform.
        </p>
        <p className="terms_condition_paragraph">
          1.2.4 Security measures shall also be put in place on our platform in
          order to safe guard your profile from unauthorized use. Security
          features shall include but not be limited to the use of user names and
          passwords, password verification and confirmation systems etc. It
          shall be your responsibility to ensure that your login and security
          information is kept safe and free from 3rd party unauthorized use. We
          will not be liable for any claims arising out of the unauthorized use
          of your profile.
        </p>
        <p className="terms_condition_paragraph">
          1.2.5 You accept that we reserve the right to alter all administrative
          processes as well as security measures in any manner that is deemed
          necessary in order to ensure the safety of our platform without
          further notice to you.
        </p>
      </div>

      {/* Section 2: Your Transactions */}
      <div className="terms_condition_section" id="section-2">
        <h2 className="terms_condition_section_header">2. YOUR TRANSACTIONS</h2>

        <h3 className="terms_condition_sub_header">
          2.1 Third Party Contact and Interactions
        </h3>
        <p className="terms_condition_paragraph">
          2.1.1 Our platform is a hub wherein events are planned seamlessly with
          innovative pathways. This may include the collation of guest and
          client details such as but not limited to emails, phone numbers,
          addresses, etc. It is your sole responsibility to ensure the safety,
          and accuracy of any data imputed on the platform.
        </p>
        <p className="terms_condition_paragraph">
          2.1.2 You are also responsible for imputing and maintaining any
          ancillary event information such as time scheduling or timelines, rsvp
          information, menus, pricing etc.
        </p>
        <p className="terms_condition_paragraph">
          2.1.3 Invitation links are created based on information provided by
          you. In the event that you have any challenges creating invitation
          links, please reach out to our customer service representatives vide
          details supplied from time to time for immediate resolution.
        </p>

        <h3 className="terms_condition_sub_header">
          2.2 Payment of Transaction Consideration
        </h3>
        <p className="terms_condition_paragraph">
          2.2.1 In the event that your transaction culminates into receiving
          payment from members of the public from time to time, in this regard,
          payments may be made via the platform in accordance with the
          guidelines provided.
        </p>
        <p className="terms_condition_paragraph">
          2.2.2 The company may in this regard partner with any necessary and
          relevant financial facility for this purpose for the provisions of any
          necessary payment links that will ensure the safest and most efficient
          payment pathways possible.
        </p>
        <p className="terms_condition_paragraph">
          2.2.3 Your funds upon payment by guests will be lodged and deposited
          in the first instance in our companies virtual dedicated accounts from
          which said funds will be remitted into your account in remittance
          cycles applicable from time to time.
        </p>
        <p className="terms_condition_paragraph">
          2.2.4 The company shall not condone the use of the platform for any
          illegal immoral, or fraudulent activities or events and shall not be
          liable in any way for any such acts and shall reserve the right to
          report any such activities to the relevant anti-graft agencies.
        </p>

        <h3 className="terms_condition_sub_header">
          2.3 Administrative Charges
        </h3>
        <p className="terms_condition_paragraph">
          2.3.1 All payments, contributions, deposits made through our platform
          shall attract administrative charges in accordance with our company's
          set-up.
        </p>

        <h3 className="terms_condition_sub_header">2.3.2 Tickets</h3>
        <p className="terms_condition_paragraph">
          A 10% service fee will be charged on the total value of all tickets
          sold through the platform.
        </p>
        <p className="terms_condition_paragraph">
          The exact amount charged to the guest will be displayed to them, while
          the fee will be deducted before your payout.
        </p>

        <h3 className="terms_condition_sub_header">2.3.3 Cash Gifts</h3>
        <p className="terms_condition_paragraph">
          A 10% service fee will be charged on the total value of all cash gifts
          received through the platform.
        </p>
        <p className="terms_condition_paragraph">
          The exact amount received from guests will be displayed to you for
          reporting purposes, while the fee will be deducted before your payout.
        </p>

        <h3 className="terms_condition_sub_header">
          2.3.4 Event Attire (Clothing and Paraphernalia)
        </h3>
        <p className="terms_condition_paragraph">
          Hosts will not be charged any service fees on the sale of event
          attire, clothing, or paraphernalia through the platform.
        </p>

        <h3 className="terms_condition_sub_header">2.4 Refund Policies</h3>
        <p className="terms_condition_paragraph">
          2.4.1 Our company and its related platforms serve as a conduit with
          which events are seamlessly planned. We are therefore not liable for
          any direct refunds to guests accordingly. To this extent, any refunds
          requested by guests shall be directed to the host in which event
          payment will be made directly by the host to the guest. Our obligation
          shall be strictly to abide by remittance cycles as agreed from time to
          time.
        </p>
        <p className="terms_condition_paragraph">
          2.4.2 You shall therefore bear full liability for any claims for
          refunds that may be brought by guests at any time and shall hold us
          harmless from any such claims.
        </p>
        <p className="terms_condition_paragraph">
          2.4.3 You shall have the ability to set up the timeline for refund
          requests that can be edited or managed by you.
        </p>
      </div>

      {/* Section 3: Termination */}
      <div className="terms_condition_section" id="section-3">
        <h2 className="terms_condition_section_header">
          3. TERMINATION OF THE AGREEMENT/EXCLUSION FROM USE
        </h2>
        <p className="terms_condition_paragraph">
          3.1 These Terms shall be effective the date of acceptance and shall
          continue indefinitely until terminated pursuant to the provisions of
          this agreement.
        </p>
        <p className="terms_condition_paragraph">
          3.2 The agreement entered into may be terminated at any time by either
          party with immediate effect and without specifying any reasons or
          without any requirement of notice, if you delete your profile, and you
          will no longer be authorized to use the platform.
        </p>
        <p className="terms_condition_paragraph">
          3.3 You may also be suspended or excluded permanently from the use of
          the services for material breaches of the obligations arising under
          applicable law or regulation and/or these Terms or any other binding
          agreements between the parties.
        </p>
        <p className="terms_condition_paragraph">
          3.4 Notwithstanding the termination of these Terms, all unsettled
          claims for payments will be pursued by us.
        </p>
      </div>

      {/* Section 4: Privacy Policy */}
      <div className="terms_condition_section" id="section-4">
        <h2 className="terms_condition_section_header">4. PRIVACY POLICY</h2>
        <p className="terms_condition_paragraph">
          4.1 We collect information about you when you register on and use our
          website, mobile applications, and any other online products and
          services (referred to hereinafter as "Services") and through other
          interactions and communications you have with us. By downloading any
          of our mobile applications, visiting our website and providing us your
          data by any means i.e. chat, phone or email, you accept that we may
          utilize such data to contact you and provide you information relevant
          to your continued use and enjoyment of our services.
        </p>

        <h3 className="terms_condition_sub_header">
          4.2 How We Use Information Collected
        </h3>
        {renderListItem(
          "a. To serve you better by improving the functionality of our services and applications."
        )}
        {renderListItem(
          "b. To send you relevant information regarding our services and offerings"
        )}
        {renderListItem(
          "c. Enable you and professional service providers to reach one another, communicate and in general perform the service which you request at any time."
        )}

        <h3 className="terms_condition_sub_header">
          4.3 Sharing of your Information
        </h3>
        {renderListItem(
          "a. Through Our Services: We share only relevant information with other Professional Service Providers to enable them to perform the requested service."
        )}
        {renderListItem(
          "b. By Order of Court: We share with the Nigerian Police and other security agencies if requested via a Court Order."
        )}

        <p className="terms_condition_paragraph">
          4.4 Our general privacy Policy will be fully applicable to you
          accordingly.
        </p>
      </div>

      {/* Section 5: Relationship of the Parties */}
      <div className="terms_condition_section" id="section-5">
        <h2 className="terms_condition_section_header">
          5. RELATIONSHIP OF THE PARTIES
        </h2>
        <p className="terms_condition_paragraph">
          5.1 We are independent contracting parties and nothing in these Terms
          shall make either party the agent or legal representative of the other
          for any purpose whatsoever, nor does it grant either party any
          authority to assume or to create any obligation on behalf of or in the
          name of the other party.
        </p>
      </div>

      {/* Section 6: Intellectual Property Rights */}
      <div className="terms_condition_section" id="section-6">
        <h2 className="terms_condition_section_header">
          6. INTELLECTUAL PROPERTY RIGHTS (COPYRIGHTED MATERIAL, AND TRADEMARK
          INFORMATION)
        </h2>
        <p className="terms_condition_paragraph">
          6.1 Our product names, service names, slogans or logos referenced on
          our websites and/or in Apps are trademarks or registered trademarks
          and therefore company property. All of the information, content, and
          materials offered are protected by copyright and other applicable laws
          of the Federal Republic of Nigeria. You shall not copy, publicly
          display, modify or distribute such material without our prior written
          consent. You may use these materials pursuant to these Terms and
          subject to the restrictions set forth herein, so long as they do not
          modify the materials or remove any copyright any proprietary rights
          notices contained therein or thereon.
        </p>
        <p className="terms_condition_paragraph">
          6.2 All right, title and interest and the services provided is and
          will remain our exclusive property.
        </p>
      </div>

      {/* Section 7: Limitation of Liabilities and Warranties */}
      <div className="terms_condition_section" id="section-7">
        <h2 className="terms_condition_section_header">
          7. LIMITATION OF LIABILITIES AND WARRANTIES
        </h2>
        <p className="terms_condition_paragraph">
          7.1 We shall not be held liable in the event of fraudulent
          transactions being successful. We will however take all reasonable
          steps to assist in the resolution of any such issues and assist in the
          recovery of any funds transferred to said 3rd party sellers by
          providing any relevant information in our records to the relevant
          antigraft agencies on your behalf.
        </p>
        <p className="terms_condition_paragraph">
          7.2 Subject to these Terms, we shall provide the in the app our
          associated billing and invoicing services. We warrant that the App
          shall substantially conform to the specifications set forth in the
          documentation and shall function substantially as intended. Our sole
          obligation under this warranty shall be limited to using reasonable
          efforts to ensure such conformity and operation and to supply versions
          of the App as soon as practicable after discovery of an error. This
          warranty shall be void if the App is modified without the written
          consent.
        </p>
        <p className="terms_condition_paragraph">
          7.3 You shall have no claim to the continuous and uninterrupted
          availability of the App or the Services. We do not warrant:
        </p>
        {renderListItem(
          "a. that operation of the App shall be uninterrupted or error free, or"
        )}
        {renderListItem(
          "b. that functions contained in the App shall operate in the combination which may be selected for use by you or meet your requirements. We shall take reasonable steps to achieve maximum possible availability and to rectify any faults in the App as quickly as possible."
        )}

        <p className="terms_condition_paragraph">
          7.4 Under no circumstances shall we be liable for your acts or
          omissions.
        </p>
        <p className="terms_condition_paragraph">
          7.5 We shall be entitled to discontinue service temporarily or
          permanently, with or without informing you, though every reasonable
          effort will be made to inform you of any interruptions in its service
          ahead of time.
        </p>
        <p className="terms_condition_paragraph">
          7.6 The services and application are provided on an "as is" and "as
          available" basis and without warranties of any kind either express or
          implied. To the fullest extent permitted by applicable law, we
          expressly disclaim all warranties and conditions of any kind, whether
          express or implied, including, but not limited to, implied warranties
          of merchantability, fitness for a particular purpose and
          non-infringement of any third-party intellectual property right. We
          make no warranty that its website, the application or any services
          will be uninterrupted, timely, secure or error free.
        </p>
        <p className="terms_condition_paragraph">
          7.7 To the fullest extent permitted under law, we will have no
          obligation or liability (whether arising in contract, warranty, tort
          (including negligence), product liability or otherwise) for any
          incidental, indirect or consequential damages or liabilities
          (including, but not limited to, any loss of data, revenue or profit)
          arising with respect to the use of the application or the platform,
          website or the services provided by us, even if we have been advised
          of the possibility of such damages. This foregoing limitation applies
          to damages arising from:
        </p>
        {renderListItem(
          "i. use or inability to use the application, the website or the services; or"
        )}
        {renderListItem(
          "ii. any other matter relating to the application, the website or the services."
        )}

        <p className="terms_condition_paragraph">
          7.8 Some jurisdictions do not allow the exclusion or limitation of
          incidental or consequential damages, so the above limitation or
          exclusion may not apply. This warranty gives you specific legal
          rights, and you may have other rights that vary from state to state.
        </p>
      </div>

      {/* Section 8: Your Warranties and Indemnity */}
      <div className="terms_condition_section" id="section-8">
        <h2 className="terms_condition_section_header">
          8. YOUR WARRANTIES AND INDEMNITY
        </h2>
        <p className="terms_condition_paragraph">
          8.1 Our legal liability under these Terms is limited to damages
          arising from our own gross negligence or willful misconduct or the
          gross negligence or willful misconduct of our employees and/or agents.
          Under no circumstances shall we be liable for your acts or omissions.
        </p>
        <p className="terms_condition_paragraph">
          8.2 You therefore warrant that beyond the termination of these terms
          against and claims against you, you shall further indemnify us to the
          fullest extent for any acts or omissions on your part that may lead to
          any losses, damages, or claims from any third parties at any time.
        </p>
      </div>

      {/* Section 9: Miscellaneous */}
      <div className="terms_condition_section" id="section-9">
        <h2 className="terms_condition_section_header">9. MISCELLANEOUS</h2>

        <h3 className="terms_condition_sub_header">9.1 Severability</h3>
        <p className="terms_condition_paragraph">
          If any part of these Terms is held to be invalid or unenforceable, the
          invalid or unenforceable provision will be deemed superseded by a
          valid, enforceable provision most closely matching the intent of the
          original provision and the remainder of the Terms will continue in
          effect.
        </p>

        <h3 className="terms_condition_sub_header">9.2 Amendments</h3>
        <p className="terms_condition_paragraph">
          we reserve the right to change these Terms from time to time. Please
          refer to our website periodically for any changes. By continuing to
          access or use the Service after we make any such changes, you agree to
          be bound by the revised Terms. The general terms and conditions may be
          consulted at any time online at our website or in App.
        </p>

        <h3 className="terms_condition_sub_header">9.3 Entirety</h3>
        <p className="terms_condition_paragraph">
          This agreement shall constitute the complete and exclusive agreement
          with respect to the subject matter of these Terms. The use of the App
          is expressly made conditional on your consent to these Terms.
        </p>

        <h3 className="terms_condition_sub_header">9.4 No Waiver</h3>
        <p className="terms_condition_paragraph">
          our failure to enforce any right or provision of these Terms will not
          be deemed a waiver of such right or provision.
        </p>

        <h3 className="terms_condition_sub_header">9.5 Force Majeure</h3>
        <p className="terms_condition_paragraph">
          we shall not be liable for any failure to perform its obligations
          under these Terms where such failure is as a result of acts of nature
          (including fire, flood, earthquake, storm, hurricane or other natural
          disaster), war, invasion, act of foreign enemies, hostilities (whether
          war is declared or not), civil war, rebellion, revolution,
          insurrection, military or usurped power or confiscation, terrorist
          activities, nationalization, government sanction, blockage, embargo,
          labor dispute, strike, lockout or interruption or failure of
          electricity, telephone or internet service.
        </p>

        <h3 className="terms_condition_sub_header">9.6 Governing Law</h3>
        <p className="terms_condition_paragraph">
          The parties agree that these Terms and any claims hereunder shall be
          governed by and subject to the laws of the Federal Republic of Nigeria
          without regard to its conflict of law provisions. Any action hereunder
          must be brought, if at all, within one (1) year from the accrual of
          the cause of action.
        </p>
      </div>

      {/* Section 10: Revisions, Changes and Updates */}
      <div className="terms_condition_section" id="section-10">
        <h2 className="terms_condition_section_header">
          10. REVISIONS, CHANGES AND UPDATES TO APP AND WEBSITE
        </h2>
        <p className="terms_condition_paragraph">
          10.1 We reserve the right to revise, change and/or update the App in
          any manner in order to develop it further and improve it
          qualitatively. It is your responsibility to ensure that the latest
          version of the App is installed on your Terminal Device.
        </p>
      </div>

      {/* Section 11: Revisions to Terms and Conditions */}
      <div className="terms_condition_section" id="section-11">
        <h2 className="terms_condition_section_header">
          11. REVISIONS, CHANGES AND UPDATES TO TERMS AND CONDITIONS
        </h2>
        <p className="terms_condition_paragraph">
          11.1 We reserve the right to revise, change and/or update the terms
          herein in any manner in order to further protect you and provide
          quality services and security. It is your responsibility to ensure
          that the latest version of the terms are properly studied and complied
          with. You will be informed in writing of any changes thereto and all
          alterations will be deemed as binding on you from the date of upload.
        </p>
      </div>
    </>
  );

  const renderGuestTerms = () => (
    <>
      {/* Section 1: Receiving Links */}
      <div className="terms_condition_section" id="section-1">
        <h2 className="terms_condition_section_header">1. RECEIVING LINKS</h2>
        <p className="terms_condition_paragraph">
          1.1 You may receive a link by virtue of an invitation to an event or
          for any issues ancillary to an event. Please ensure that invites are
          for events that are familiar to you as such acceptance may subject you
          to receiving promotional emails, or phone calls regarding the accepted
          event.
        </p>
        <p className="terms_condition_paragraph">
          1.2 You may also receive payment links for purchases towards an event.
          Please ensure that payments are made towards events that are familiar
          to you as such payments are made to 3rd party financial institutions
          and will not be refundable by our company.
        </p>
      </div>

      {/* Section 2: Profile Creation */}
      <div className="terms_condition_section" id="section-2">
        <h2 className="terms_condition_section_header">2. PROFILE CREATION</h2>
        <p className="terms_condition_paragraph">
          2.1 You may be required to give detailed information about yourself
          via questionnaires and forms provided on the application portal. All
          answers to which are important as they form a part of your record
          which will be used for administrative purposes. You have a legal
          obligation to take reasonable care not to make a misrepresentation of
          yourself.
        </p>
        <p className="terms_condition_paragraph">
          2.2 In the event that any detail you have supplied to us is incorrect,
          you must advise the company immediately. Failure of which may lead to
          the termination or deactivation of your profile.
        </p>
        <p className="terms_condition_paragraph">
          2.3 You further agree to comply with any applicable administrative
          charges with regards to registration. You will be informed of any such
          charges in writing. Failure to make payment of the said charges shall
          be grounds for the denial of registration and you will therefore be
          barred or limited from optimal use of our app and website.
        </p>
      </div>

      {/* Section 3: Security Features */}
      <div className="terms_condition_section" id="section-3">
        <h2 className="terms_condition_section_header">3. SECURITY FEATURES</h2>
        <p className="terms_condition_paragraph">
          3.1 Due to the nature of transactions carried out on our platforms,
          the importance of security measure cannot be over emphasized. We
          reserve the right to adopt any security measures deemed fit in order
          to safeguard users of our platform at all times and also to ensure
          that our space is a safe business forum. We therefore may request that
          you go through our administrative processes for security and safety
          from time to time during and after your registration and listing
          process.
        </p>
        <p className="terms_condition_paragraph">
          3.2 The company reserves the right to make requests at any time for
          additional documents or information relating to your person or
          business. Failure to comply will lead to the suspension or termination
          of the use of our platform.
        </p>
        <p className="terms_condition_paragraph">
          3.3 You hereby consent to the submission and verification of your
          personal information and agree that failure to comply with our
          administrative process shall be a ground for denial of use of our
          platform.
        </p>
        <p className="terms_condition_paragraph">
          3.4 Security measures shall also be put in place on our platform in
          order to safe guard your profile from unauthorized use. Security
          features shall include but not be limited to the use of user names and
          passwords, password verification and confirmation systems etc. It
          shall be your responsibility to ensure that your login and security
          information is kept safe and free from 3rd party unauthorized use. We
          will not be liable for any claims arising out of the unauthorized use
          of your profile.
        </p>
        <p className="terms_condition_paragraph">
          3.5 You accept that we reserve the right to alter all administrative
          processes as well as security measures in any manner that is deemed
          necessary in order to ensure the safety of our platform without
          further notice to you.
        </p>
      </div>

      {/* Section 4: Administrative Charges */}
      <div className="terms_condition_section" id="section-4">
        <h2 className="terms_condition_section_header">
          4. ADMINISTRATIVE CHARGES
        </h2>
        <p className="terms_condition_paragraph">
          4.1 All payments, contributions, deposits made through our platform
          shall attract administrative charges in accordance with our company's
          set-up.
        </p>

        <h3 className="terms_condition_sub_header">
          4.1 Event Attire (Clothing and Paraphernalia Purchases)
        </h3>
        <p className="terms_condition_paragraph">
          A 5% service fee will be added to the total price of all clothing and
          paraphernalia purchased through the platform.
        </p>
        <p className="terms_condition_paragraph">
          This fee will be calculated and displayed at checkout and included in
          your final payment amount.
        </p>

        <h3 className="terms_condition_sub_header">
          4.2 Tickets and Cash Gifts
        </h3>
        <p className="terms_condition_paragraph">
          Guests will not be charged any service fees on the purchase of tickets
          or when sending cash gifts through the platform.
        </p>
        <p className="terms_condition_paragraph">
          The price you see for these items or amounts is the exact amount you
          will pay.
        </p>
      </div>

      {/* Section 5: Refund Policies */}
      <div className="terms_condition_section" id="section-5">
        <h2 className="terms_condition_section_header">5. REFUND POLICIES</h2>
        <p className="terms_condition_paragraph">
          5.1 Our company and its related platforms serve as a conduit with
          which events are seamlessly planned. We are therefore not liable for
          any direct refunds to guests accordingly. To this extent, any refunds
          requested by guests shall be directed to the host in which event
          payment may be made directly by the host to the guest.
        </p>
      </div>

      {/* Section 6: Privacy Policy */}
      <div className="terms_condition_section" id="section-6">
        <h2 className="terms_condition_section_header">6. PRIVACY POLICY</h2>
        <p className="terms_condition_paragraph">
          6.1 We collect information about you when you register on and use our
          website, mobile applications, and any other online products and
          services (referred to hereinafter as "Services") and through other
          interactions and communications you have with us. By downloading any
          of our mobile applications, visiting our website and providing us your
          data by any means i.e. chat, phone or email, you accept that we may
          utilize such data to contact you and provide you information relevant
          to your continued use and enjoyment of our services.
        </p>

        <h3 className="terms_condition_sub_header">
          6.2 How We Use Information Collected
        </h3>
        {renderListItem(
          "a. To serve you better by improving the functionality of our services and applications."
        )}
        {renderListItem(
          "b. To send you relevant information regarding our services and offerings"
        )}
        {renderListItem(
          "c. Enable you and professional service providers to reach one another, communicate and in general perform the service which you request at any time."
        )}

        <h3 className="terms_condition_sub_header">
          6.3 Sharing of your Information
        </h3>
        {renderListItem(
          "a. Through Our Services: We share only relevant information with other Professional Service Providers to enable them to perform the requested service."
        )}
        {renderListItem(
          "b. By Order of Court: We share with the Nigerian Police and other security agencies if requested via a Court Order."
        )}

        <p className="terms_condition_paragraph">
          6.4 Our general privacy Policy will be fully applicable to you
          accordingly.
        </p>
      </div>

      {/* Section 7: Relationship of the Parties */}
      <div className="terms_condition_section" id="section-7">
        <h2 className="terms_condition_section_header">
          7. RELATIONSHIP OF THE PARTIES
        </h2>
        <p className="terms_condition_paragraph">
          7.1 We are independent contracting parties and nothing in these Terms
          shall make either party the agent or legal representative of the other
          for any purpose whatsoever, nor does it grant either party any
          authority to assume or to create any obligation on behalf of or in the
          name of the other party.
        </p>
      </div>

      {/* Section 8: Intellectual Property Rights */}
      <div className="terms_condition_section" id="section-8">
        <h2 className="terms_condition_section_header">
          8. INTELLECTUAL PROPERTY RIGHTS (COPYRIGHTED MATERIAL, AND TRADEMARK
          INFORMATION)
        </h2>
        <p className="terms_condition_paragraph">
          8.1 Our product names, service names, slogans or logos referenced on
          our websites and/or in Apps are trademarks or registered trademarks
          and therefore company property. All of the information, content, and
          materials offered are protected by copyright and other applicable laws
          of the Federal Republic of Nigeria. You shall not copy, publicly
          display, modify or distribute such material without our prior written
          consent. You may use these materials pursuant to these Terms and
          subject to the restrictions set forth herein, so long as they do not
          modify the materials or remove any copyright any proprietary rights
          notices contained therein or thereon.
        </p>
        <p className="terms_condition_paragraph">
          8.2 All right, title and interest and the services provided is and
          will remain our exclusive property.
        </p>
      </div>

      {/* Section 9: Limitation of Liabilities and Warranties */}
      <div className="terms_condition_section" id="section-9">
        <h2 className="terms_condition_section_header">
          9. LIMITATION OF LIABILITIES AND WARRANTIES
        </h2>
        <p className="terms_condition_paragraph">
          9.1 Whilst we assist in ensuring the safety and seamlessness of
          transactions, we shall not be held liable in the event of fraudulent
          transactions being successful. We will however take all reasonable
          steps to assist in the resolution of any such issues and assist in the
          recovery of any funds transferred to said 3rd party sellers by
          providing any relevant information in our records to the relevant
          antigraft agencies on your behalf.
        </p>
        <p className="terms_condition_paragraph">
          9.2 Subject to these Terms, we shall provide the in the app our
          associated billing and invoicing services. We warrant that the App
          shall substantially conform to the specifications set forth in the
          documentation and shall function substantially as intended. Our sole
          obligation under this warranty shall be limited to using reasonable
          efforts to ensure such conformity and operation and to supply versions
          of the App as soon as practicable after discovery of an error. This
          warranty shall be void if the App is modified without the written
          consent.
        </p>
        <p className="terms_condition_paragraph">
          9.3 You shall have no claim to the continuous and uninterrupted
          availability of the App or the Services. We do not warrant:
        </p>
        {renderListItem(
          "a. that operation of the App shall be uninterrupted or error free, or"
        )}
        {renderListItem(
          "b. that functions contained in the App shall operate in the combination which may be selected for use by you or meet your requirements. We shall take reasonable steps to achieve maximum possible availability and to rectify any faults in the App as quickly as possible."
        )}

        <p className="terms_condition_paragraph">
          9.4 Under no circumstances shall we be liable for your acts or
          omissions.
        </p>
        <p className="terms_condition_paragraph">
          9.5 We shall be entitled to discontinue service temporarily or
          permanently, with or without informing you, though every reasonable
          effort will be made to inform you of any interruptions in its service
          ahead of time.
        </p>
        <p className="terms_condition_paragraph">
          9.6 The services and application are provided on an "as is" and "as
          available" basis and without warranties of any kind either express or
          implied. To the fullest extent permitted by applicable law, we
          expressly disclaim all warranties and conditions of any kind, whether
          express or implied, including, but not limited to, implied warranties
          of merchantability, fitness for a particular purpose and
          non-infringement of any third-party intellectual property right. We
          make no warranty that its website, the application or any services
          will be uninterrupted, timely, secure or error free.
        </p>
        <p className="terms_condition_paragraph">
          9.7 To the fullest extent permitted under law, we will have no
          obligation or liability (whether arising in contract, warranty, tort
          (including negligence), product liability or otherwise) for any
          incidental, indirect or consequential damages or liabilities
          (including, but not limited to, any loss of data, revenue or profit)
          arising with respect to the use of the application or the platform,
          website or the services provided by us, even if we have been advised
          of the possibility of such damages. This foregoing limitation applies
          to damages arising from:
        </p>
        {renderListItem(
          "i. use or inability to use the application, the website or the services; or"
        )}
        {renderListItem(
          "ii. any other matter relating to the application, the website or the services."
        )}

        <p className="terms_condition_paragraph">
          9.8 Some jurisdictions do not allow the exclusion or limitation of
          incidental or consequential damages, so the above limitation or
          exclusion may not apply. This warranty gives you specific legal
          rights, and you may have other rights that vary from state to state.
        </p>
      </div>

      {/* Section 10: Your Warranties and Indemnity */}
      <div className="terms_condition_section" id="section-10">
        <h2 className="terms_condition_section_header">
          10. YOUR WARRANTIES AND INDEMNITY
        </h2>
        <p className="terms_condition_paragraph">
          10.1 Our legal liability under these Terms is limited to damages
          arising from our own gross negligence or willful misconduct or the
          gross negligence or willful misconduct of our employees and/or agents.
          Under no circumstances shall we be liable for your acts or omissions.
        </p>
        <p className="terms_condition_paragraph">
          10.2 You therefore warrant that beyond the termination of these terms
          against and claims against you, you shall further indemnify us to the
          fullest extent for any acts or omissions on your part that may lead to
          any losses, damages, or claims from any third parties at any time.
        </p>
      </div>

      {/* Section 11: Miscellaneous */}
      <div className="terms_condition_section" id="section-11">
        <h2 className="terms_condition_section_header">11. MISCELLANEOUS</h2>

        <h3 className="terms_condition_sub_header">11.1 Severability</h3>
        <p className="terms_condition_paragraph">
          If any part of these Terms is held to be invalid or unenforceable, the
          invalid or unenforceable provision will be deemed superseded by a
          valid, enforceable provision most closely matching the intent of the
          original provision and the remainder of the Terms will continue in
          effect.
        </p>

        <h3 className="terms_condition_sub_header">11.2 Amendments</h3>
        <p className="terms_condition_paragraph">
          we reserve the right to change these Terms from time to time. Please
          refer to our website periodically for any changes. By continuing to
          access or use the Service after we make any such changes, you agree to
          be bound by the revised Terms. The general terms and conditions may be
          consulted at any time online at our website or in App.
        </p>

        <h3 className="terms_condition_sub_header">11.3 Entirety</h3>
        <p className="terms_condition_paragraph">
          This agreement shall constitute the complete and exclusive agreement
          with respect to the subject matter of these Terms. The use of the App
          is expressly made conditional on your consent to these Terms.
        </p>

        <h3 className="terms_condition_sub_header">11.4 No Waiver</h3>
        <p className="terms_condition_paragraph">
          our failure to enforce any right or provision of these Terms will not
          be deemed a waiver of such right or provision.
        </p>

        <h3 className="terms_condition_sub_header">11.5 Force Majeure</h3>
        <p className="terms_condition_paragraph">
          we shall not be liable for any failure to perform its obligations
          under these Terms where such failure is as a result of acts of nature
          (including fire, flood, earthquake, storm, hurricane or other natural
          disaster), war, invasion, act of foreign enemies, hostilities (whether
          war is declared or not), civil war, rebellion, revolution,
          insurrection, military or usurped power or confiscation, terrorist
          activities, nationalization, government sanction, blockage, embargo,
          labor dispute, strike, lockout or interruption or failure of
          electricity, telephone or internet service.
        </p>

        <h3 className="terms_condition_sub_header">11.6 Governing Law</h3>
        <p className="terms_condition_paragraph">
          The parties agree that these Terms and any claims hereunder shall be
          governed by and subject to the laws of the Federal Republic of Nigeria
          without regard to its conflict of law provisions. Any action hereunder
          must be brought, if at all, within one (1) year from the accrual of
          the cause of action.
        </p>
      </div>

      {/* Section 12: Revisions, Changes and Updates */}
      <div className="terms_condition_section" id="section-12">
        <h2 className="terms_condition_section_header">
          12. REVISIONS, CHANGES AND UPDATES TO APP AND WEBSITE
        </h2>
        <p className="terms_condition_paragraph">
          12.1 We reserve the right to revise, change and/or update the App in
          any manner in order to develop it further and improve it
          qualitatively. It is your responsibility to ensure that the latest
          version of the App is installed on your Terminal Device.
        </p>
      </div>

      {/* Section 13: Revisions to Terms and Conditions */}
      <div className="terms_condition_section" id="section-13">
        <h2 className="terms_condition_section_header">
          13. REVISIONS, CHANGES AND UPDATES TO TERMS AND CONDITIONS
        </h2>
        <p className="terms_condition_paragraph">
          13.1 We reserve the right to revise, change and/or update the terms
          herein in any manner in order to further protect you and provide
          quality services and security. It is your responsibility to ensure
          that the latest version of the terms are properly studied and complied
          with. You will be informed in writing of any changes thereto and all
          alterations will be deemed as binding on you from the date of upload.
        </p>
      </div>
    </>
  );

  return (
    <div className="terms_condition_page">
      <HeroSection
        title="Terms & Conditions"
        description={getHeroDescription()}
        showDecorative={true}
        variant="terms"
        activeNav="terms"
        onNavClick={handleNavClick}
        onLoginClick={handleLogin}
        onGetStartedClick={handleGetStarted}
      />

      <div className="terms_condition_main_content">
        <div className="terms_condition_sidebar_and_content">
          <aside className="terms_condition_sidebar">
            <h3 className="terms_condition_sidebar_title">
              Term & Condition Content
            </h3>
            <nav className="terms_condition_sidebar_nav">
              {userType === "host" ? renderHostSidebar() : renderGuestSidebar()}
            </nav>
          </aside>

          <div className="terms_condition_content_area">
            <div className="terms_condition_header_section">
              <div className="terms_condition_updated_badge">
                Updated May 21, 2025
              </div>

              <div className="terms_condition_user_type_toggle">
                <button
                  className={`terms_condition_toggle_btn ${
                    userType === "host" ? "active" : ""
                  }`}
                  onClick={() => setUserType("host")}
                >
                  Host/Event Manager
                </button>
                <button
                  className={`terms_condition_toggle_btn ${
                    userType === "guest" ? "active" : ""
                  }`}
                  onClick={() => setUserType("guest")}
                >
                  Guest
                </button>
              </div>
            </div>

            {userType === "host" ? renderHostTerms() : renderGuestTerms()}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
